import { Injectable } from '@angular/core';
declare var layer: any;
declare var ready: any;
declare var $: any;

@Injectable()
export class LayerService {
    constructor() {
        ready.run($);
        // layer.ready();
    }
    // 初始化全局配置
    config(options?: Object) {
        layer.config(options);
    }
    // 原始核心方法
    open(options: Object) {
        return layer.open(options);
    }
    // 普通信息框
    alert(content: string, options?: Object, yes?: Function) {
        return layer.alert(content, options, yes);
    }
    // 询问框
    confirm(content: string, options?: Object, yes?: Function, cancel?: Function) {
        return layer.confirm(content, options, yes, cancel);
    }
    // 提示框
    msg(content: string, options?: Object, end?: Function) {
        return layer.msg(content, options, end);
    }
    // 加载层
    load(icon?: number, options?: Object) {
        return layer.load(icon, options);
    }
    // tips层
    tips(content: string, follow?, options?: Object) {
        return layer.tips(content, follow, options);
    }
    //  关闭特定层
    close(index: number) {
        layer.close(index);
    }
    // 关闭所有层
    closeAll(type?: string) {
        layer.closeAll(type);
    }
    // 重新定义层的样式
    style(index: number, cssStyle: Object) {
        layer.style(index, cssStyle);
    }
    // 改变层的标题
    title(title: string, index: number) {
        layer.title(title, index);
    }
    // 获取iframe页的DOM
    getChildFrame(selector, index: number) {
        return layer.getChildFrame(selector, index);
    }
    // 获取特定iframe层的索引
    getFrameIndex(windowName: string) {
        return layer.getFrameIndex(windowName);
    }
    // 指定iframe层自适应
    iframeAuto(index: number) {
        return layer.iframeAuto(index);
    }
    // 重置特定iframe url
    iframeSrc(index: number, url: string) {
        return layer.iframeSrc(index, url);
    }
    // 置顶当前窗口
    setTop(layero) {
        layer.setTop(layero);
    }
    // 手工执行最大小化
    full(index?: any) {
        layer.full(index);
    }
    min(index?: any) {
        layer.min(index);
    }
    restore(index?: any) {
        layer.restore(index);
    }
    // 输入层
    prompt(options: Object, yes?: Function) {
        return layer.prompt(options, yes);
    }
    // tab层
    tab(options: Object) {
        return layer.tab(options);
    }
    // 相册层
    photos(options: Object) {
        return layer.photos(options);
    }
}
